var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-layout',{attrs:{"type":_vm.LAYOUT_TYPES.TOP_SIDE,"logo":_vm.logo,"menus":_vm.menus,"title":_vm.title,"i18nRender":_vm.i18nRender,"activeMenus":_vm.activeMenus},scopedSlots:_vm._u([{key:"header-right",fn:function(){return [_c('right-header')]},proxy:true}])},[_c('router-view-custom',{attrs:{"alive":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }